// Generated by purs version 0.13.8
"use strict";
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Constants = require("../Lunarbox.Constants/index.js");
var withLogo = function (content) {
    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("with-logo") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("left") ])([ Lunarbox_Component_Utils.container("logo")([ Halogen_HTML_Elements.img([ Halogen_HTML_Properties.src(Lunarbox_Constants.logoWithText) ]) ]) ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("right") ])([ content ]) ]);
};
module.exports = {
    withLogo: withLogo
};
